// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aac68abc","695":"6c298266"}[chunkId] + ".chunk.js";
};